<template>
  <div id="timeline-widget">
    <v-card color="grey darken-1">
      <v-toolbar card>
        <v-toolbar-title><h2>Upcoming</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-tooltip left>
            <v-icon slot="activator">mdi mdi-calendar-search</v-icon>
            <span>View Calendar</span>
          </v-tooltip>
        </v-toolbar-side-icon>
      </v-toolbar>
      <v-timeline
        align-top
        dense
      >
        <template v-for="event in Events">
          <v-timeline-item 
            :key="event.date"
            small
            :color="eventColor(event.topic)"
          >
            <v-layout pt-3>
              <v-flex xs3>
                <strong>{{event.date.slice(5)}}</strong>
              </v-flex>
              <v-flex>
                <strong>{{event.title}}</strong>
                <div v-if="event.subtitle" class="caption">{{event.subtitle}}</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </template>

      </v-timeline>
    </v-card>
  </div>
</template>

<script>
import DashboardStore from '../../../stores/DashboardStore'

export default {
  data () {
    return {
      Events: DashboardStore.data.Events.data.events
    }
  },
  methods: {
    eventColor: function (topic) {
      if (topic === 'Business Plan Competition') {
        return 'success'
      } else {
        return 'info'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/dashboard/widgets/Timeline.vue